var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { InnerHtml } from "../../innerhtml";
export const DynamicComponent = React.forwardRef((_a, ref) => {
    var { tag = "div", children, hasHtml, isUppercase } = _a, props = __rest(_a, ["tag", "children", "hasHtml", "isUppercase"]);
    if (hasHtml) {
        return _jsx(InnerHtml, Object.assign({}, props, { as: tag, content: children, ref: ref }));
    }
    // @ts-nocheck
    const Element = tag;
    return (_jsx(Element, Object.assign({}, props, { className: `gdds-element ${props.className || ""}`, ref: ref }, { children: children })));
});
DynamicComponent.displayName = "DynamicTypography";
